// in src/users.js
import React, {cloneElement} from 'react';
import {List, Datagrid, TextField, DateField, FunctionField, Show, SimpleShowLayout,
    sanitizeListRestProps,
    CreateButton,
    Filter, SelectInput, ReferenceInput, TopToolbar, Pagination} from 'react-admin';
import {IColumn} from '../../consts/Entities';
import { areYouStrangeString } from '../utils/TextChecker';
import {IListActionsProps} from "../../consts/interfaces/Interfaces";
import {makeStyles} from "@material-ui/core";
import {COUNTRIES} from "../../consts/Names";


const InquiryShow = props => (
   <Show
       {...props}
       title=" "
   >
       <SimpleShowLayout>
         <FunctionField source="message" sortable={false} render={record => areYouStrangeString(record,'message', false)} label={false}/>
       </SimpleShowLayout>
   </Show>
);

const ListActions = (props: IListActionsProps, ...rest) => {
    const {className, filters, resource, showFilter, displayedFilters, filterValues, basePath} = props;

    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters &&
                cloneElement(filters, {
                    resource,
                    showFilter,
                    displayedFilters,
                    filterValues,
                    context: 'button'
                })}
            <CreateButton basePath={basePath}/>
        </TopToolbar>
    );
};

const useFilterStyles = makeStyles((theme) => ({
    status: {width: 150}
}));
const optionRenderer = choice => `${choice.name}`;
export const InquiryManagementFilters = (props) => {
    const classes = useFilterStyles();
    return (
        <Filter {...props}>
            <ReferenceInput label="Country" source={"country_id"} reference="countries">
                <SelectInput source={COUNTRIES.id} />
            </ReferenceInput>
        </Filter>
    );
};

export const InquiryManagement = (props: IColumn) => {
   return (
      <List {...props}
            bulkActionButtons={false}
            title="Inquiry Management"
            exporter={false}
            sort={{field:'updated_at', order:'DESC'}}
            perPage={25}
            pagination={<Pagination rowsPerPageOptions={[25,50,100,200]}/>}
            filters={<InquiryManagementFilters />}
            actions={<ListActions />}
      >
         <Datagrid expand={<InquiryShow />}>
            <DateField source="updated_at" showTime={true} label="Sending Date-time"/>
             <TextField source="user.username" label="Name of sender" sortable={false}/>
             <TextField source="user.email" label="E-mail address of sender" sortable={false}/>
             <TextField source="api_version" sortable={false}/>
             <TextField source="app_build" sortable={false}/>
             <TextField source="device" sortable={false}/>
             <TextField source="os_version" sortable={false}/>
             <FunctionField source="message" sortable={false} render={record => areYouStrangeString(record,'message', 50)} label="Inquiry detail"/>
         </Datagrid>
      </List>
   );
};

